import React from 'react';

export const SearchableContext = React.createContext();
export default SearchableContext;
